import { useRef } from "react";

/** Keeps list based effects stable when a parent recreates an equivalent array. */
export default function useStableStringArray(values: string[]): string[] {
    const current = useRef(values);
    if (current.current.length !== values.length || current.current.some((value, index) => value !== values[index])) {
        current.current = values;
    }
    return current.current;
}
